// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { AssociationRole, AssociationRoleSchema } from 'api/gen/AssociationRole';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';

const requiredPart = t.interface({
  content: t.union([t.array(AssociationRoleSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelAssociationRoleSchema = excess(requiredPart);

export interface PagedModelAssociationRole extends t.TypeOf<typeof PagedModelAssociationRoleSchema> {}
